import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { IAppState } from '@myStore/app.state';
import { Store } from '@ngrx/store';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';

@Component({
  selector: 'app-search-field',
  templateUrl: './search-field.component.html',
  styleUrls: ['./search-field.component.sass'],
})
export class SearchFieldComponent implements AfterViewInit {
  @ViewChild('input', { static: true }) input!: ElementRef;
  @ViewChild('inputSecond', { static: true }) inputSecond!: ElementRef;
  @Output() searchHandler = new EventEmitter<string | null>();
  @Input() qParams: { [key: string]: string | number } = {};
  @Input() qInitialParams: { [key: string]: string | number } = {};
  @Input() isDisabled?: boolean;
  @Input() helperText?: string;
  @Input() autoComplete?: boolean;
  @Input() label?: string = 'Поиск';
  @Input() fillClass?: MatFormFieldAppearance;
  @Input() class?: string;
  @Input() value?: string;
  @Input() maxlength?: number;
  private prevInputLength = 0;

  constructor(private _store: Store<IAppState>) {}

  ngAfterViewInit(): void {
    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        map(e => {
          const event = e as Event;
          const target = event.target as HTMLInputElement;

          return target.value;
        }),
        debounceTime(400),
        distinctUntilChanged(),
        tap((value: string) => {
          this.search(value);
        })
      )
      .subscribe();
  }

  search(value: string): void {
    if (value.length > 1) {
      this.prevInputLength = 2;
      this.searchHandler.emit(value);
    }

    if (
      (this.prevInputLength === 2 || this.prevInputLength === 0) &&
      value.length <= 1
    ) {
      this.prevInputLength = 0;
      this.searchHandler.emit(null);
    }
  }
}
